import { Contact } from '../../components/address-book';
import { AddressResponseData } from '../../global-types';
import { AddressTypeCode } from '../../global-types/addresses';

type MappedAddresses = {
  senderContact: Contact | null;
  recipientContacts: Contact[];
};

// mapAddressesToContacts maps the returned addresses from the backend to a Contact array
// and returns the recipient-addresses and the sender address
export const mapAddressesToContacts = ({
  addresses,
  accountId,
}: {
  addresses: AddressResponseData[] | null | undefined;
  accountId: string | undefined;
}): MappedAddresses => {
  if (!addresses || addresses.length === 0) return { senderContact: null, recipientContacts: [] };

  const recipientContacts: Contact[] = [];
  addresses.forEach((address: AddressResponseData) => {
    if (address.address_type_code === AddressTypeCode.RECIPIENT) {
      recipientContacts.push({
        contact_id: address.address_id,
        account_id: accountId || '',
        first_name: address.first_name,
        last_name: address.last_name,
        company_name: address.company_name,
        address_line_1: address.address_line_1,
        address_line_2: address.address_line_2,
        city: address.city,
        state_code: address.state_code,
        zip: address.zip,
        country_code: address.country_code,
        contact_type_code: address.address_type_code,
        created_at: address.created_at,
        last_updated_at: address.last_updated_at,
        is_verified: address.is_verified,
        address_hash_id: address.address_hash_id || '',
      });
    }
  });

  const senderAddress: AddressResponseData | undefined = addresses.find(
    (address) => address.address_type_code === AddressTypeCode.SENDER,
  );
  if (!senderAddress) return { senderContact: null, recipientContacts };

  const senderContact: Contact = {
    contact_id: senderAddress.address_id,
    account_id: accountId || '',
    first_name: senderAddress.first_name,
    last_name: senderAddress.last_name,
    company_name: senderAddress.company_name,
    address_line_1: senderAddress.address_line_1,
    address_line_2: senderAddress.address_line_2,
    city: senderAddress.city,
    state_code: senderAddress.state_code,
    zip: senderAddress.zip,
    country_code: senderAddress.country_code,
    contact_type_code: senderAddress.address_type_code,
    created_at: senderAddress.created_at,
    last_updated_at: senderAddress.last_updated_at,
    is_verified: senderAddress.is_verified,
    address_hash_id: senderAddress.address_hash_id || '',
  };

  return { senderContact, recipientContacts };
};
